import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: absolute;
  height: 100%;
  background: #fff;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 4;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.7em;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 95px;
`;

export const Text = styled.div`
  display: flex;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }

  &.animated.infinite {
    animation-iteration-count: infinite;
  }

  &.animated.delay {
    animation-delay: 0.3s;
  }

  ${mediaMaxWidth.phone`
    max-width: 80%;
    text-align: center;
    margin: 10px auto;
    font-size: 0.85em;
  `}
`;
Text.displayName = "Text";

export const Check = styled.img`
  width: 40px;
  height: 40px;
  align-self: center;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
  }

  &.animated {
    animation-duration: 1s;
    animation-fill-mode: both;
  }
`;
